import React from "react";
import { FaLinkedin, FaGithub,FaTelegram,FaWhatsapp, FaEnvelope, FaTwitter } from "react-icons/fa";
import "./Homepage.css";
import { Link } from 'react-router-dom';
import ResumePDF from './images/Resume.pdf';

function Navbarmain() {
  return (
    <div className="bg-gradient-to-r from-blue-900 via-blue-500 to-blue-300 auto-h-screen">
      <header className="bg-gradient-to-r from-blue-300 via-blue-300 to-blue-400">
        <nav className="container mx-auto px-3 py-3 flex flex-wrap justify-between items-center">
          <div className="flex items-center">
            <a className="text-blue-1000 text-4xl font-bold hover:text-blue-100 mr-4" href="#">
              Portfolio
            </a>
          </div>
          <div className="flex mt-2 md:mt-0">
            <Link to="/" className="py-2 px-2 text-blue-900 font-bold hover:text-blue-100 text-lg mr-1">
              Home
            </Link>
            <a
              className="py-2 px-4 text-blue-900 font-bold hover:text-blue-100 text-lg mr-1"
              href="https://bikashsingh-github.github.io/Travel-Website/"
            >
              Projects
            </a>
            <a
              className="py-2 px-4 text-blue-900 font-bold hover:text-blue-100 text-lg mr-1"
              href={ResumePDF}
              download="resume.pdf"
            >
              Resume
            </a>
            <a
              className="py-2 px-2 text-blue-900 font-bold hover:text-blue-100 text-lg mr-0"
              href="https://api.whatsapp.com/send?phone=919606791418&text=Hello!%20I%20would%20like%20to%20get%20in%20touch."
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </a>
          </div>
          <div className="flex items-center">
            <div className="ml-1">
              <a className="hover:text-blue-100" href="https://www.linkedin.com/in/bikashsingh-reactjs/">
                <FaLinkedin size={34} />
              </a>
            </div>
            <div className="ml-4">
              <a className="hover:text-blue-100" href="mailto:lookupbikash@gmail.com">
                <FaEnvelope size={34} />
              </a>
            </div>
            <div className="ml-4">
              <a className="hover:text-blue-100" href="https://github.com/BikashSingh-GitHub">
                <FaGithub size={34} />
              </a>
            </div>
            <div className="ml-4">
              <a className="hover:text-blue-100" href="https://twitter.com/BikashSinghTwit">
                <FaTwitter size={34} />
              </a>
            </div>
            <div className="ml-4">
              <a className="hover:text-blue-100" href="https://api.whatsapp.com/send?phone=919606791418&text=Hello!%20I%20would%20like%20to%20get%20in%20touch.">
                <FaWhatsapp size={34} />
              </a>
            </div>
            <div className="ml-4">
              <a className="hover:text-blue-100" href="https://t.me/Bikash_Kumar_Singh">
                <FaTelegram size={34} /> {/* Assuming you have a Telegram icon imported */}
              </a>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default Navbarmain;
